import React, { useState, useEffect } from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import RenderItem from "../../common/renderItem";
import RenderCartItem from "../../common/renderCartItem";
import { formatCurrency } from "../../common/format-currency";
import MyStorage from "../../common/MyStorage";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
} from "../../redux/actions/postActions";
import { connect, useStore } from "react-redux";
import Loader from "react-loader-spinner";
import { List } from "react-content-loader";
import { KMTracking } from "../../components/Tracking/KMTracking";
import _ from "lodash";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import cleanURL from "../../common/cleanURL";
import { Link } from "react-router-dom";
import { isTemplateExpression } from "typescript";

let isCustomDelivery: Array<any> = [];
let isSelfFulfufilment: Array<any> = [];
const MyListLoader = () => <List />;
let allItems: any = [];
let tempArray: any = [];
let selfCollectionLocations: any = 0;
function MyBag(props) {
  const [productsInCart, setProductsInCart] = useState(false);
  const [fullfilment, setFullfilment] = useState("");
  const [trendingProducts, setTrendingProducts] = useState<Object>([]);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [subTotal, setSubTotal] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [productsID, setProductsID] = useState("");
  const [productsInfoDelivery, setProductsInfoDelivery] = useState([]);
  const [deliveryItem, setDeliveryItem] = useState<any>({});
  const [cartItems, setCartItems] = useState<any>([]);
  const [cartItemsPromo, setCartItemsPromo] = useState<any>([]);
  const [deliveryLocations, setDeliveryLocations] = useState(0);
  const [cartSpinner, setCartSpinner] = useState(false);
  const [cartSpinnerItem, setCartSpinnerItem] = useState("");
  const [deleiverySelectPrice, setDeleiverySelectPrice] = useState(0);
  const [couponCodePrice, setCouponCodePrice] = useState(0);
  const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
  const [fulfilmentSelect, setFulfilmentSelect] = useState("");
  const [deliveryDataList, setDeliveryDataList] = useState<any>([]);
  const [is_loading, setIsLoading] = useState(false);
  const [show_fullfilment_error, setShowFulfilmentError] = useState(false);
  const [fulfilment_error_text, setFulfilmentErrorText] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState<any>({});
  const [list_loading, setListLoading] = useState(false);
  const [dynamic_text, setDynamictext] = useState("");
  const [delivery_time_estimation, setDeliveryTimeEstimation] = useState("");
  const [crossClicked, setIsCrossClicked] = useState(false);
  const [deliveryItemID, setDeliveryItemID] = useState<any>("");
  const [selfLocationsCounter, setSelfLocationCounter] = useState(0);
  const [selectFulfilmentError, setSelectFulfilmentError] = useState(false);
  const [promoCode, setPromoCode] = useState<any>("");
  const [promoCodeProducts, setPromoCodeProducts] = useState<any>([]);
  const [promoCodeStatus, setPromoCodeStatus] = useState<boolean>();
  const [showPromoCodeError, setShowPromoCodeError] = useState<any>(false);
  const [promoCodeErrorText, setPromoCodeErrorText] = useState<any>(
    "Please enter valid promo code"
  );
  const [showDiscount, setShowDiscount] = useState<any>(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [is_promo_loading, setIsPromoLoading] = useState(false);
  const [promoResponse, setPromoResponse] = useState<any>("");

  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  var ACF;
  useEffect(() => {
    const storage = new MyStorage();
    let userID = storage.getUserId();
    let accessToken = storage.getaccess_token();
    getDeliveryItem();
    getSettings();
    getShoutouts();
    console.log("UseEffect called");
    const is_logged_in = storage.getloggedIn();
    console.log("UseEffect called checkking condition", userID && accessToken);
    if (userID && accessToken) {
    } else {
      props?.history?.push("/login", { from: "My Bag" });
      return;
    }
    if (is_logged_in || is_logged_in == "true") {
      setProductsInCart(true);
      seeCart();
      fetchAddresses();
    } else {
      setProductsInCart(false);
    }

    const Price = subTotal + deleiverySelectPrice + couponCodePrice;
    let data = {
      "Bag total amount": props.cart_count,
      "Bag product count": props.cart_amount,
    };
    tracker("viewedbag", data);
  }, []);

  useEffect(() => {
    if (promoCode) {
      handlePromoCodeApplication();
    }
  }, [cartTotal]);

  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const getShoutouts = async () => {
    let checkoutText: any = [];
    await new WebApiCalls().getShoutouts().then((_response) => {
      if (_response.data) {
        if (_response.data.length > 0) {
          _response.data.map((item) => {
            if (item.type == "eStoreCheckoutText" && item.status == "Y") {
              checkoutText.push(item);
            }
          });
          let sort = checkoutText.sort((a, b) => {
            return (
              new Date(b.publish_date).getTime() -
              new Date(a.publish_date).getTime()
            );
          });
          setDynamictext(sort[0]?.description);
        }
      }
    });
  };
  const getSettings = async () => {
    await new WebApiCalls().getSettings().then((_response) => {
      if (_response.data) {
        if (_response.data.Items.length > 0) {
          _response.data.Items.map((item) => {
            if (item.item_name == "estore_delivery_time") {
              setDeliveryTimeEstimation(item.item_detail);
            }
          });
        }
      }
    });
  };
  const fetchAddresses = async () => {
    // const contactId = localStorage.getItem("contactIDFrasers");
    const email = localStorage.getItem("emailFrasers");
    const authentication = localStorage.getItem("authenticationFrasers");
    let temparr2: any = [];
    await new WebApiCalls().getAllAddress(authentication).then((response) => {
      if (response.data) {
        response.data.all_addresses.map((item: any) => {
          if (item.is_default == "Y") {
            setDeliveryAddress(item);
            temparr2.unshift(item);
          } else {
            temparr2.push(item);
          }
        });
      }
    });
    if (temparr2.length > 0) {
      if (temparr2.length == 1 && temparr2[0].is_default == "N") {
        setDeliveryAddress(temparr2[0]);
        setToDefault(temparr2[0]?.address_id);
      }
      setDeliveryDataList(temparr2);
    } else {
      setDeliveryDataList([]);
    }
  };
  const setToDefault = async (_addr_id) => {
    const storage = new MyStorage();

    const contactId = storage.getContactIDFrasers();
    const authentication = storage.getauthenticationFrasers();

    let itemObj = {
      address_id: _addr_id,
      contact_id: contactId,
    };
    await new WebApiCalls()
      .setTodefault(itemObj, authentication)
      .then((response) => {
        if (response.statusCode) {
          fetchAddresses();
        }
      });
  };
  const updateCart = async () => {
    console.log("Coming in update cart");
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .seeCart(userID, accessToken)
      .then(async (response) => {
        // setCartItemsPromo(response)
        let total = 0;
        let itemID: string[] = [];
        response.Records.map(async (item) => {
          total = total + item.SubTotal;
          itemID.push(item.ID);
          let a: any = 0;
          a = response.Records.map((item) => {
            return parseInt(a + item.Quantity);
          });
          let b = 0;
          a.map((aitem) => {
            b = aitem + b;
            new MyStorage().setCartCount(JSON.stringify(b));
            props.UpdateCartCount(b);
            setTotalItems(b);
          });
          new MyStorage().setCartAmount(total);
          props.UpdateCartAmount(total);
          setSubTotal(total);
        });
        seeCart();
      });
  };
  const deleteItemCart = async (item, deletingDelivery = false) => {
    setIsCrossClicked(true);
    console.log("Item is:	", item);
    let storeName = "";
    cartItems.map((items, i) => {
      items.itemCart.map((i, j) => {
        if (i.ID == item.ID) {
          storeName = items.DisplayName;
          items.itemCart.splice(j, 1);
        }
      });
    });

    // console.log("Cart Spinner item:	", item.ID)
    setCartSpinner(true);
    setCartSpinnerItem(item.ID);
    // let userID = await localStorage.getItem("UserId");
    // let accessToken = await localStorage.getItem("access_token");
    const storage = new MyStorage();
    let userID = await storage.getUserId();
    let accessToken = await storage.getaccess_token();
    let color = "";
    let size = "";
    let BrandName = "";
    item.ItemDetail &&
      item.ItemDetail.CustomFields &&
      item.ItemDetail.CustomFields.length > 0 &&
      item.ItemDetail.CustomFields.map((item, index) => {
        if (item.Name === "Brand") {
          BrandName = item.Values[0];
        }
      });
    item.ItemDetail &&
      item.ItemDetail.Variants &&
      item.ItemDetail.Variants.length > 0 &&
      item.ItemDetail.Variants.map((item, index) => {
        if (item.GroupName === "Size") {
          size = item.Name;
        }
        if (item.GroupName === "Color") {
          color = item.Name;
        }
      });
    const data = {
      currency: item.CurrencyCode,
      value: item.ItemDetail.Price,
      items: [
        {
          item_id: item.ItemDetail.ID,
          item_name: item.ItemDetail.Name,
        }],
      "Product id": item.ItemDetail.ID,
      "Product price": item.ItemDetail.Price,
      "Product quantity": item.Quantity,
      "Product name": item.ItemDetail.Name,
      "Brand name": BrandName,
      "Store name": storeName,
      "Product sku": item.ItemDetail.SKU,
      "Product size": size,
      "Product color": color,
    };
    await tracker("removedfrombag", data);
    await tracker("removed_from_cart", data);

    await new WebApiCalls()
      .deleteItemCart(userID, accessToken, item.ID)
      .then(async (response) => {
        console.log("response deleteItemCart", response);
        await seeCart(deletingDelivery);
        await checkFulfilment(fullfilment);
      });
  };
  const getDeliveryItem = async () => {
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf;
    } else {
      ACF = await new WebApiCalls().getCustomFieldsCode(true);
      props.setACF(ACF);
    }
    let deliveryItemID = ACF["FrasersDeliveryItemID"];
    setDeliveryItemID(deliveryItemID);
    if (deliveryItemID) {
      await new WebApiCalls()
        .getSingleItem(deliveryItemID)
        .then((_response) => {
          setDeliveryItem(_response);
        });
    }
    getTrendingProducts();
  };
  const getTrendingProducts = async () => {
    // ACF = await new WebApiCalls().getCustomFieldsCode(true);

    let customFieldQueries = [
      {
        Code: ACF["Trending"] || ACF["trending"],
        Operator: "equal",
        Value: "1",
      },
    ];
    let tempArr: any = [];
    let itemObj = {
      CustomFieldQueries: customFieldQueries,
      Sort: "name",
    };
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getItemsByFilters(itemObj, accessToken)
      .then((_response) => {
        if (_response?.Records) {
          tempArr = _response.Records;
        }
      })
      .catch((error) => console.log("Error: ", error));

    tempArr = tempArr.filter((item) => item.ID);
    setTrendingProducts(tempArr);
  };
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          top: isTabletOrMobileDevice || isTabletOrMobile ? "25%" : "35%",
          marginRight: "10px",
        }}
        onClick={onClick}
      >
        <div className="slick-next">
          <img src="images/next.png" />
        </div>
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          top: isTabletOrMobileDevice || isTabletOrMobile ? "25%" : "35%",
          marginLeft: "10px",
        }}
        onClick={onClick}
      >
        <div className="slick-prev">
          <img src="images/prev.png" />
        </div>
      </div>
    );
  }
  const renderMiniSlider = (imgArray: any, slides: number) => {
    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: slides,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };
    return (
      <Slider {...settings}>
        {imgArray?.map((item: any, index: number) => {
          if (!item.ID) {
            return;
          }
          return (
            <RenderItem
              item={item}
              key={index}
              onClickItem={onClickItem}
              is_slider={true}
              from={"My Bag"}
            />
          );
        })}
      </Slider>
    );
  };
  const onClickItem = (_item) => {
    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "My Bag",
    });
  };
  const seeCart = async (deletingDelivery = false) => {
    if (deletingDelivery) {
      setListLoading(false);
    } else if (crossClicked) {
      setListLoading(false);
    } else {
      setListLoading(true);
    }
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getCartDetail(userID, accessToken)
      .then(async (Response) => {
        console.log("Checking coming in see cart and stuff", Response);
        if (Response.errorType) {
          //redirect to login if expired
          props?.history?.push("/login", { from: "Product Description" });
        } else if (
          !Response ||
          Response === null ||
          Response?.body?.length == 0
        ) {
          setCartSpinner(false);
          setSubTotal(0);
          setProductsInCart(false);
          props.UpdateCartAmount(0);
          props.UpdateCartCount(0);
          new MyStorage().setCartCount("0");
          setTotalItems(0);
          setProductsID("");
          setProductsInfoDelivery([]);
          allItems = [];
          setCartItems([]);
          setCartItemsPromo([]);
          setListLoading(false);
          setIsCrossClicked(false);
        } else if (Response.statusCode === 200) {
          allItems = Response.body;
          setCartItems(Response.body);
          setCartItemsPromo(Response?.body);
          setListLoading(false);
          setIsCrossClicked(false);

          setCartSpinner(false);
          await new WebApiCalls()
            .seeCart(userID, accessToken)
            .then(async (response) => {
              let a: any = 0;
              let b: any = 0;
              a = response.Records.map((item) => {
                return parseInt(a + item.Quantity);
              });
              a.map((aitem) => {
                b = b + aitem;
              });
              new MyStorage().setCartCount(JSON.stringify(b));
              props.UpdateCartCount(b);
              setTotalItems(b);
              let total = 0;
              let itemID: any = [];
              await response.Records.map(async (item) => {
                total = total + item.SubTotal;
                itemID.push(item.ID);
                let obj = {
                  ID: item.ItemDetail.ID,
                };
                props.UpdateCartAmount(
                  totalAfterDiscount > 0 ? totalAfterDiscount : total
                );
                new MyStorage().setCartAmount(
                  JSON.stringify(
                    totalAfterDiscount > 0 ? totalAfterDiscount : total
                  )
                );
                setSubTotal(total);
                setProductsID(itemID);
                // setDeliveryLocations(Response?.body?.length)
                response?.Records.map((item) => {
					let itemObj = {
                    item_id: item.ItemDetail.ID,
                    item_name: item.ItemDetail.Name,
                  }
                  tempArray.push(itemObj)
                })

              });
              let view_cart = {
                value: total,
                items: tempArray
              }
              setCartTotal(total);
              tracker("view_cart", view_cart)
            });
        } else {
          setCartSpinner(false);
          setSubTotal(0);
          setProductsInCart(false);
          props.UpdateCartAmount(0);
          props.UpdateCartCount(0);
          new MyStorage().setCartCount("0");
          setTotalItems(0);
          setProductsID("");
          setProductsInfoDelivery([]);
          setCartItems([]);
          setCartItemsPromo([]);
          allItems = [];
          setListLoading(false);
          setIsCrossClicked(false);
        }
      });
  };
  const onClickRenderItem = (_item) => {
    // if(_item.Name.includes('/')){
    // 	props?.history?.push(`/product/${_item.Name.replace(/\\|\//g, '_')}/${_item.ID}`, { cat1: `${props?.location?.state?.cat1}`, cat2: `${props?.location?.state?.cat2}`, path: `/product/${_item.Name.replace(/\\|\//g, '_')}/${_item.ID}` },{from:'My Bag'})
    // }
    // else{
    // 	props?.history?.push(`/product/${_item.Name}/${_item.ID}`, { cat1: `${props?.location?.state?.cat1}`, cat2: `${props?.location?.state?.cat2}`, path: `/product/${_item.Name}/${_item.ID}` },{from:'My Bag'})
    // }
    props?.history?.push(
      `/product/${cleanURL(_item.Name)}/${
        _item.ParentID ? _item.ParentID : _item.ID
      }`,
      { from: "My Bag" }
    );
  };
  const onClickStoreName = (_item) => {
    props?.history?.push(
      `/brand/${cleanURL(_item?.DisplayName)}/${_item?.ID}`,
      { from: "My Bag" }
    );
  };
  const renderCartItems = (itemData) => {
    let frxdel = false;

    return (
      <div>
        {itemData &&
          itemData.map((item, index) => {
            const storeAddress = item.CustomFields
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("Store Address")
                ).length > 0
                ? item.CustomFields.filter((item) =>
                    item.Name.includes("Store Address")
                  )[0].Values[0]
                : ""
              : "";
            const mallName = item.CustomFields
              ? item.CustomFields.filter((item) => item.Name.includes("Mall"))
                  .length > 0
                ? item.CustomFields.filter((item) =>
                    item.Name.includes("Mall")
                  )[0].Values[0]
                : ""
              : "";
            const pickupPoint = item.CustomFields
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("Pickup Location")
                ).length > 0
                ? item.CustomFields.filter((item) =>
                    item.Name.includes("Pickup Location")
                  )[0].Values[0]
                : ""
              : "";
            let unitNo = item.CustomFields
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("Unit Number")
                ).length > 0
                ? item.CustomFields.filter((item) =>
                    item.Name.includes("Unit Number")
                  )[0].Values[0]
                : ""
              : "";
            unitNo = unitNo + (mallName ? ", " + mallName : "");

            if (item.itemCart && deliveryItemID) {
              item.itemCart.map((item) => {
                if (item.ItemDetail.ID == deliveryItemID) {
                  deleteItemCart(item, true);
                  frxdel = false;
                } else {
                  frxdel = true;
                }
              });
            }
            let storeName = item.DisplayName;
            console.log("frxdel = ", frxdel);

            let fulfilmentDelivery = item.CustomFields
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("FulfilmentDelivery")
                ).length > 0
                ? item.CustomFields.filter((item) =>
                    item.Name.includes("FulfilmentDelivery")
                  )[0].Values[0]
                : ""
              : "";

            let fulfilmentSelfCollection = item.CustomFields
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("FulfilmentSelfCollection")
                ).length > 0
                ? item.CustomFields.filter((item) =>
                    item.Name.includes("FulfilmentSelfCollection")
                  )[0].Values[0]
                : ""
              : "";
            return (
              frxdel && (
                <div key={index} style={{ paddingBottom: 13 }}>
                  <div
                    className="info"
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      let bannerUrl = item.CustomFields
                        ? item.CustomFields.filter((item) =>
                            item.Name.includes("BannerURL")
                          ).length > 0
                          ? item.CustomFields.filter((item) =>
                              item.Name.includes("BannerURL")
                            )[0].Values[0]
                          : ""
                        : "";
                      // let staticbanner = require('../../images/storeDefault.jpg')
                      // this.props.addSelectedSortValue("")
                      // this.props.addSelectedFilterValue("")
                      // this.props.addSelectedFilterID("")
                      // this.props.history.push("/show-all", {
                      // 	screenName: item.DisplayName,
                      // 	comingFromStore: true,
                      // 	ID: item.ID,
                      // 	img: bannerUrl.length > 0 ? bannerUrl : staticbanner,
                      // 	type: "showStores",
                      // });
                    }}
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      to={`/brand/${cleanURL(item?.DisplayName)}/${item?.ID}`}
                      onClick={() => {
                        onClickStoreName(item);
                      }}
                    >
                      <div
                        className="name"
                        style={{ fontWeight: 500, color: "#333" }}
                      >
                        {item.DisplayName.replace(/&amp;/g, "&")}
                      </div>
                      {unitNo && (
                        <div className="loc" style={{ color: "#666" }}>
                          {unitNo}
                        </div>
                      )}

                      {/* {fullfilment == 'delivery' && fulfilmentDelivery == 'frasers' && <div className="messagedesign" style={{ display: 'inline-block' }}>
												{'Delivery & tracking updates will be provided by Frasers eStore.'}
											</div>} */}
                      {fullfilment == "pickup" &&
                        fulfilmentSelfCollection == "na" && (
                          <div
                            className="messagedesign"
                            style={{
                              display: "inline-block",
                              padding: "6px 6px 6px",
                              fontSize: "12px",
                            }}
                          >
                            {"Self collection is not available for this store"}
                          </div>
                        )}
                      {/* {fullfilment == 'pickup' && fulfilmentSelfCollection != 'na' && <div className="messagedesign" style={{ display: 'inline-block' }}>
												{'Self collection available.'}
											</div>} */}
                      {fullfilment == "delivery" && fulfilmentDelivery == "na" && (
                        <div
                          className="messagedesign"
                          style={{
                            display: "inline-block",
                            padding: "6px 6px 6px",
                            fontSize: "12px",
                          }}
                        >
                          {"Delivery is not available for this store"}
                        </div>
                      )}
                      {fullfilment == "delivery" &&
                        fulfilmentDelivery == "merchant" && (
                          <div
                            className="messagedesign"
                            style={{
                              display: "inline-block",
                              padding: "6px 6px 6px",
                              fontSize: "12px",
                            }}
                          >
                            {`Items from this store will be delivered directly by ${item.DisplayName.replace(
                              /&amp;/g,
                              "&"
                            )}`}
                          </div>
                        )}
                      <div className="loc" style={{ color: "#666" }}>
                        {fulfilmentSelect === "pickup" && pickupPoint}
                      </div>
                    </Link>
                  </div>

                  {item.itemCart.map((item, index1) => {
                    return (
                      <div style={{ cursor: "pointer" }}>
                        <RenderCartItem
                          item={item}
                          storeName={storeName}
                          key={index1}
                          deleteItemCart={deleteItemCart}
                          seeCart={seeCart}
                          onClickItem={onClickRenderItem}
                          updateCart={updateCart}
                          is_loading={cartSpinner}
                          spinning_item={cartSpinnerItem}
                          // ACF={ACF}
                          // history={this.props.history}
                        />
                      </div>
                    );
                  })}
                </div>
              )
            );
          })}
      </div>
    );
  };
  const startCheckOut = () => {
    let deliveryError = false;
    let pickupError = false;
    let frasersDelivery = false;
    // console.log("Delivery address: ", Object.values(deliveryAddress).length)
    // alert("Delivery address: " + deliveryAddress + "")

    if (promoCode == "") {
      new MyStorage().setPromoResponse(JSON.stringify({}));
    }

    if (fullfilment == "") {
      setSelectFulfilmentError(true);
      window.scrollTo(0, 0);
      return;
    }
    if (fullfilment) {
      let data = {
        Fulfilment: fullfilment,
        "Product quantity": props.cart_count,
        "Coupon code": couponCodePrice ? couponCodePrice : "",
      };
      tracker("startedcheckout", data);
    }

    setIsLoading(true);
    let itemArray: any = []
    let cartProducts:any = [];
    cartItems.map((item) => {
      item.itemCart.map((product: any, productIndex: any): void => {
        cartProducts.push(product);
      });
      let fulfilmentDelivery = item.CustomFields
        ? item.CustomFields.filter((item) =>
            item.Name.includes("FulfilmentDelivery")
          ).length > 0
          ? item.CustomFields.filter((item) =>
              item.Name.includes("FulfilmentDelivery")
            )[0].Values[0]
          : "frasers"
        : "";

      let fulfilmentSelfCollection = item.CustomFields
        ? item.CustomFields.filter((item) =>
            item.Name.includes("FulfilmentSelfCollection")
          ).length > 0
          ? item.CustomFields.filter((item) =>
              item.Name.includes("FulfilmentSelfCollection")
            )[0].Values[0]
          : "pickup" //added for default case
        : "";

      if (fullfilment == "") {
        setShowFulfilmentError(true);
        setFulfilmentErrorText("Please select fulfilment method");
        setIsLoading(false);
      } else if (
        fullfilment == "delivery" &&
        Object.keys(deliveryAddress).length == 0
      ) {
        deliveryError = true;
        setShowFulfilmentError(true);
        setFulfilmentErrorText("Please select delivery address");
        setIsLoading(false);
      } else if (fullfilment == "pickup" && fulfilmentSelfCollection == "na") {
        pickupError = true;
        setShowFulfilmentError(true);
        setFulfilmentErrorText(
          "Self collection is not available for some stores. Please review your order."
        );
        setIsLoading(false);
      } else if (fullfilment == "delivery" && fulfilmentDelivery == "na") {
        setShowFulfilmentError(true);
        setFulfilmentErrorText(
          "Delivery is not available for some stores. Please review your order."
        );
        deliveryError = true;
        setIsLoading(false);
      }

      if (fullfilment == "delivery" && fulfilmentDelivery == "frasers") {
        frasersDelivery = true;
      }

      item.itemCart.map((item) => {
        let itemObj = {
          item_id: item.ItemDetail.ID,
          item_name: item.ItemDetail.Name,
        }
        itemArray.push(itemObj)
      })
    });
    let begin_checkout = {
      currency: "SGD",
      value: subTotal + deliveryItem?.Price + couponCodePrice,
      items: itemArray
    }
    tracker("begin_checkout", begin_checkout)

    if (
      !show_fullfilment_error &&
      !pickupError &&
      !deliveryError &&
      !selectFulfilmentError
    ) {
      setShowFulfilmentError(false);
      setIsLoading(false);
      props?.history?.push({
        pathname: "/select-payment-method",
        state: {
          type: fullfilment,
          productsID: productsID,
          deliveryAddress: deliveryAddress,
          frasersDelivery: frasersDelivery,
          couponCode: promoCodeStatus && promoCode ? promoResponse : "",
          cartItems: cartProducts,
        },
      });
    }
  };

  const checkFulfilment = (text) => {
    isCustomDelivery = [];
    // isSelfFulfufilment = []
    selfCollectionLocations = 0;
    setShowFulfilmentError(false);
    setFulfilmentErrorText("");

    let x;
    let y;
    if (text == "delivery") y = "delivery";
    else if (text == "pickup") x = "pickup";
    // console.log("All Items:	",allItems)
    if (x) {
      // console.log("Total count:	", allItems.length, "	", selfCollectionLocations)

      allItems.map((item) => {
        let fulfilmentSelfCollection = item.CustomFields
          ? item.CustomFields.filter((item) =>
              item.Name.includes("FulfilmentSelfCollection")
            ).length > 0
            ? item.CustomFields.filter((item) =>
                item.Name.includes("FulfilmentSelfCollection")
              )[0].Values[0]
            : ""
          : "";
        if (!(fulfilmentSelfCollection == "na")) {
          selfCollectionLocations = selfCollectionLocations + 1;
          setSelfLocationCounter(selfCollectionLocations);
        }
        isSelfFulfufilment.push(fulfilmentSelfCollection);
        // console.log('HIIIIII = ', isSelfFulfufilment)
        if (isSelfFulfufilment.includes("na")) {
          setShowFulfilmentError(true);
          setFulfilmentErrorText(
            "Self collection is not available for some stores. Please review your order."
          );
          return;
        }
      });

      // this.setState({
      // 	fulfilmentSelect: "pickup",
      // 	deleiverySelectPrice: 0,
      // 	deleiverySelect: "",
      // });
    }
    if (y) {
      allItems.map((item) => {
        let fulfilmentDelivery = item.CustomFields
          ? item.CustomFields.filter((item) =>
              item.Name.includes("FulfilmentDelivery")
            ).length > 0
            ? item.CustomFields.filter((item) =>
                item.Name.includes("FulfilmentDelivery")
              )[0].Values[0]
            : ""
          : "";

        isCustomDelivery.push(fulfilmentDelivery);
        if (isCustomDelivery.includes("na")) {
          setShowFulfilmentError(true);
          setFulfilmentErrorText(
            "Delivery is not available for some stores. Please review your order."
          );
          return;
        }
      });
    }
  };

  const handlePromoCodeApplication = async (cartItemsPassed = undefined) => {
    try {
      //return new Promise(async (resolve, reject) => {
      setIsPromoLoading(true);
      const storage = new MyStorage();
      const contact_id = storage.getContactIDFrasers();
      let cartItemsLocal = cartItemsPassed || cartItems;
      let accessToken = await storage.getaccess_token();
      let products = [] as any;
      let totalQuantity = 0 as any;
      let totalAmount = formatCurrency(subTotal + deliveryItem?.Price);
      cartItemsLocal?.map((_item) => {
        let prod = _item.itemCart.map((_item2) => {
          totalQuantity = parseInt(totalQuantity) + parseInt(_item2.Quantity);
          return {
            value: _item2?.ItemDetail?.ParentID
              ? _item2?.ItemDetail?.ParentID
              : _item2?.ItemDetail?.ID,
            label: _item2.ItemDetail.Name,
            price: _item2.ItemDetail.Price,
            qty: _item2.Quantity,
            total: _item2.SubTotal,
          };
        });
        products = [...products, ...prod];
      });
      totalAmount = totalAmount.toString().split("$")[1];
      if (promoCode && products?.length > 0) {
        const response = await new WebApiCalls()
          .applyingPromoCode(
            accessToken,
            promoCode,
            contact_id,
            products,
            totalAmount,
            totalQuantity
          )
            if (response?.status && response?.status == "success") {
              setIsPromoLoading(false);
              setPromoCodeStatus(true);
              // let products = JSON.parse(response?.discount_products);
              // if (Object.keys(response?.details?.products).length > 0) {
              // 	setPromoCodeProducts(Object.keys(response?.details?.products))
              // }
              // else {
              // 	setPromoCodeProducts([])
              // }
              // setPromoDiscountType(response?.discount_type)
              // productExistCheck(products) //method called
              let responseDetails = response?.details;
              responseDetails.promoCode = promoCode;
              getMerchants(
                JSON.parse(responseDetails?.discount_merchants)[0]?.value,
                responseDetails
              );
              new MyStorage().setCartAmount(
                JSON.stringify(response?.details?.total_after_discount)
              );
              setTotalAfterDiscount(response?.details?.total_after_discount);
              setShowDiscount(true);
              setDiscountAmount(
                parseFloat(response?.details?.total) -
                  parseFloat(response?.details?.total_after_discount)
              );
            } else if (response?.status && response?.status == "failure") {
              setIsPromoLoading(false);
              setPromoCodeErrorText(response?.reason);
              setShowPromoCodeError(true);
              setPromoCode("");
              setPromoCodeStatus(false);
              setDiscountAmount(0);
              setShowDiscount(false);
              setIsPromoLoading(false);
              setPromoCodeProducts([]);
              setPromoResponse("");
              setTotalAfterDiscount(parseFloat(totalAmount));
            } else {
              setIsPromoLoading(false);
              console.log("Error occured.....");
              setPromoResponse("");
            }
           return (response);
      } else {
        setIsPromoLoading(false); 
        console.log("OOppppsssss......");
      }
    //});
    } catch (error) {
      setIsPromoLoading(false);
    }
  };

  const getMerchants = async (merchantID, promoObject) => {
    await new WebApiCalls().getAllMerchants().then((response) => {
      console.log(
        "Checking merchant response",
        response.body.Records,
        merchantID
      );
      if (response && response.body && response.body.Records) {
        let tempList = response.body.Records;
        tempList?.length > 0 &&
          tempList?.map((item, index) => {
            if (item?.ID == merchantID) {
              const subMidID = item?.CustomFields
                ? item?.CustomFields?.length > 0
                  ? item?.CustomFields?.filter((item2) =>
                      item2?.Name?.includes("2c2p Sub Mid")
                    ).length > 0
                    ? item?.CustomFields?.filter((item2) =>
                        item2?.Name?.includes("2c2p Sub Mid")
                      )[0].Values[0]
                    : ""
                  : ""
                : "";
              if (subMidID !== "") {
                promoObject.subMID = subMidID;
                console.log("Object before setting", promoObject, subMidID);
                setPromoResponse(promoObject);
                // new MyStorage().setPromoResponse(JSON.stringify(promoObject))
                return;
              }
            }
          });
      }
    });
  };

  const showError = (id) => {
    // selfCollectionLocations = 0
    console.log("Id is :	", id);
    let deliveryError = false;
    let pickupError = false;
    let frasersDelivery = false;
    console.log("Cart Items:	", cartItems);

    cartItems.map((item) => {
      let fulfilmentDelivery = item.CustomFields
        ? item.CustomFields.filter((item) =>
            item.Name.includes("FulfilmentDelivery")
          ).length > 0
          ? item.CustomFields.filter((item) =>
              item.Name.includes("FulfilmentDelivery")
            )[0].Values[0]
          : ""
        : "";

      let fulfilmentSelfCollection = item.CustomFields
        ? item.CustomFields.filter((item) =>
            item.Name.includes("FulfilmentSelfCollection")
          ).length > 0
          ? item.CustomFields.filter((item) =>
              item.Name.includes("FulfilmentSelfCollection")
            )[0].Values[0]
          : ""
        : "";

      if (id == "pickup" && fulfilmentSelfCollection == "na") {
        pickupError = true;
        setShowFulfilmentError(true);
        setFulfilmentErrorText(
          "Self collection is not available for some stores. Please review your order."
        );
        setIsLoading(false);
      } else if (id == "delivery" && fulfilmentDelivery == "na") {
        //merchant
        setShowFulfilmentError(true);
        setFulfilmentErrorText(
          "Delivery is not available for some stores. Please review your order."
        );
        deliveryError = true;
        setIsLoading(false);
      } else {
        setShowFulfilmentError(false);
      }

      if (id == "delivery" && fulfilmentDelivery == "frasers") {
        console.log("Delivery");
        frasersDelivery = true;
      }
    });

    /**Case for single Item Deleted from a store with multiple items */
    if (id == "delete") {
      if (fullfilment == "pickup") {
        let x = cartItems.map((item) => {
          return item.ID == cartSpinnerItem && item.CustomFields
            ? item.CustomFields.filter((item) =>
                item.Name.includes("FulfilmentSelfCollection")
              ).length > 0
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("FulfilmentSelfCollection")
                )[0].Values[0]
              : ""
            : "";
        });
        console.log("X is:	", x);

        if (x[0]) {
          setShowFulfilmentError(false);
        }
      } else if (fullfilment == "delivery") {
        let x = cartItems.map((item) => {
          return item.ID == cartSpinnerItem && item.CustomFields
            ? item.CustomFields.filter((item) =>
                item.Name.includes("FulfilmentDelivery")
              ).length > 0
              ? item.CustomFields.filter((item) =>
                  item.Name.includes("FulfilmentDelivery")
                )[0].Values[0]
              : ""
            : "";
        });
        console.log("X is:	", x);
        if (x[0]) {
          setShowFulfilmentError(false);
        }
      }
      // if(!show_fullfilment_error && !pickupError && !deliveryError){
      // 	setShowFulfilmentError(false)
      // 	setIsLoading(false)
      // 	props?.history?.push({
      // 		pathname: '/select-payment-method',
      // 		state: {
      // 			type: fullfilment,
      // 			productsID: productsID,
      // 			deliveryAddress: deliveryAddress,
      // 			frasersDelivery: frasersDelivery // if frasersDelivery == true add delivery item
      // 		}
      // 	})
      // }
    }
  };
  return (
    <div>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        {/* mainmenu */}
        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />
        {/* /mainmenu */}

        {/* /content */}
        {productsInCart == true ? (
          <div className="content">
            {/* checkout */}
            <div className="checkout">
              {/* left */}
              <div className="left-column">
                {/* qty-continue */}
                <div className="qty-continue">
                  <div className="qty">Shopping Bag ({totalItems})</div>
                  <Link
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    to={"/"}
                  >
                    Continue Shopping
                  </Link>
                </div>
                {/* /qty-continue */}

                {list_loading && !crossClicked ? (
                  <MyListLoader />
                ) : (
                  renderCartItems(cartItems)
                )}
              </div>
              {/* /left */}

              {/* right */}
              <div className="right-column">
                {/* checkout-box */}
                <div className="checkout-box">
                  {/* /code */}
                  {/*} greynote */}
                  {/* /greynote */}
                  {/* fulfilment */}
                  {/*------------------------------------------------- */}
                  <div className="promo-code">
                    <div className="title">Promo Code</div>
                    {showPromoCodeError && (
                      <div className="error" style={{ display: "block" }}>
                        {promoCodeErrorText}
                      </div>
                    )}
                    {/* <!-- greynote --> */}
                    {promoCodeStatus && (
                      <div
                        className="greynote promo"
                        style={{ display: "block", marginBottom: 10 }}
                      >
                        <div className="title nocap">{promoCode} applied</div>
                        {/* Promo code is valid from 1-30 March 2021 on selected items. Code can be used once per shopper with minimum spend of $50 per order. Cannot be used with other promo codes. */}
                        <a
                          className="remove"
                          onClick={() => {
                            setPromoCodeStatus(false);
                            setPromoCode("");
                            setShowPromoCodeError(false);
                            setDiscountAmount(0);
                            setTotalAfterDiscount(0);
                            new MyStorage().setCartAmount(
                              JSON.stringify(subTotal)
                            );
                          }}
                        >
                          Remove
                        </a>
                      </div>
                    )}
                    {/* <!-- greynote --> */}
                    <div className="code-entry">
                      {/*style={{ display: "none" }} */}
                      <input
                        type="text"
                        placeholder="Enter Promo Code"
                        id="pCode"
                        value={promoCode}
                        onChange={(e) => {
                          if (e.target.value) {
                            setShowPromoCodeError(false);
                          }
                          setPromoCode(e.target.value);
                        }}
                      />
                      <a
                        className="blackbutton"
                        onClick={() => {
                          setShowPromoCodeError(false);
                          if (promoCode) {
                            handlePromoCodeApplication();
                          } else {
                            setShowPromoCodeError(true);
                          }
                        }}
                      >
                        {is_promo_loading ? (
                          <Loader
                            type="TailSpin"
                            color="white"
                            height={18}
                            width={18}
                          />
                        ) : (
                          "APPLY"
                        )}
                      </a>
                    </div>
                  </div>
                  {/*------------------------------------------------- */}
                  <div className="fulfilment">
                    <div className="title" style={{ marginBottom: "11px" }}>
                      Fulfilment
                    </div>
                    {show_fullfilment_error && (
                      <div
                        style={{ display: "inline-block", marginBottom: 10 }}
                        className="messagedesign"
                      >
                        {fulfilment_error_text}
                      </div>
                    )}
                    <div
                      className="option"
                      style={{ marginTop: fullfilment ? 0 : 5 }}
                    >
                      <label htmlFor="pickup">
                        Self Collection
                        <input
                          type="radio"
                          className="radioo"
                          name="fulfilment"
                          id="pickup"
                          onChange={(e) => {
                            setFullfilment("pickup");
                            setSelectFulfilmentError(false);
                            setShowFulfilmentError(false);
                            setDeleiverySelectPrice(0);
                            showError(e.target.id);
                            checkFulfilment(e.target.id);
                          }}
                        />
                      </label>

                      {/* greynote */}
                      {fullfilment == "pickup" && (
                        <div
                          className="greynote pickup"
                          style={{ display: "block" }}
                        >
                          <div className="title">
                            SELF COLLECT FROM {selfLocationsCounter} LOCATION(S)
                          </div>
                          {/*FREE PICKUP */}
                          Your bag contains items from {
                            selfLocationsCounter
                          }{" "}
                          locations. Please check items for self collection
                          information.
                        </div>
                      )}
                      {/* greynote */}
                    </div>
                    <div className="option">
                      <label htmlFor="delivery">
                        Delivery
                        <input
                          type="radio"
                          className="radioo"
                          name="fulfilment"
                          id="delivery"
                          onChange={(e) => {
                            setFullfilment("delivery");
                            setSelectFulfilmentError(false);
                            setShowFulfilmentError(false);
                            showError(e.target.id);
                            checkFulfilment(e.target.id);
                          }}
                        />
                      </label>
                      {/* greynote */}
                      {fullfilment == "delivery" && (
                        <>
                          {deliveryDataList?.length > 0 &&
                            deliveryDataList?.map(
                              (item: any, index: number) => {
                                return (
                                  <label
                                    key={index}
                                    className="greynote delivery"
                                    style={{ display: "block" }}
                                  >
                                    <div className="address-check">
                                      <div className="address">
                                        <div className="title">
                                          {item?.contact_name}{" "}
                                          {item?.is_default == "Y" ? (
                                            <span>{"(Default)"}</span>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        {item?.street_name +
                                          " " +
                                          item?.building_name}
                                        <br />
                                        Singapore {item?.postal_code}
                                        <br />
                                        <br />
                                        <strong>
                                          {deliveryItem?.Price == 0
                                            ? "Free "
                                            : formatCurrency(
                                                deliveryItem?.Price
                                              )}{" "}
                                          Delivery
                                        </strong>
                                        <br />
                                        {delivery_time_estimation}
                                      </div>
                                      {deliveryAddress && (
                                        <div className="check">
                                          <input
                                            type="radio"
                                            name="delivery-address"
                                            value={deliveryAddress}
                                            defaultChecked={
                                              item?.is_default == "Y"
                                                ? true
                                                : false
                                            }
                                            id="address01"
                                            onChange={() => {
                                              setDeliveryAddress(item);
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </label>
                                );
                              }
                            )}
                          <label
                            className="greynote delivery"
                            style={{ display: "block" }}
                            onClick={() => {
                              props?.history?.push("/add-address", {
                                comingFromCart: true,
                                zeroAddress:
                                  deliveryDataList.length > 0 ? false : true,
                              });
                            }}
                          >
                            <span className="add-address">ADD NEW ADDRESS</span>
                          </label>
                        </>
                      )}
                      {/* /greynote */}
                    </div>
                    {selectFulfilmentError && (
                      <div
                        className="error"
                        style={{ display: "block", marginTop: 10 }}
                      >
                        Please select fulfilment
                      </div>
                    )}
                  </div>
                  {/* /fulfilment */}

                  {/* order-summary */}
                  <div className="order-summary">
                    <div className="title">Order Summary</div>

                    {/* subtotal */}
                    <div className="sub">
                      {/* subtotal */}
                      <div className="fees items">
                        <div className="text">Subtotal</div>
                        <div className="price">{formatCurrency(subTotal)}</div>
                      </div>
                      {showDiscount && (
                        <div className="fees items">
                          <div className="text">Discount</div>
                          <div className="price">
                            {formatCurrency(discountAmount)}
                          </div>
                        </div>
                      )}
                      {/* /subtotal */}

                      {/* deliveryfee */}
                      {fullfilment == "delivery" && (
                        <div
                          className="fees delivery"
                          style={{ display: "flex" }}
                        >
                          <div className="text">Delivery</div>
                          <div className="price">
                            {deliveryItem?.Price == 0
                              ? "Free"
                              : formatCurrency(deliveryItem?.Price)}
                          </div>
                        </div>
                      )}
                      {fullfilment == "pickup" && (
                        <div
                          className="fees delivery"
                          style={{ display: "flex" }}
                        >
                          <div className="text">Self Collection</div>
                          <div className="price">Free</div>
                        </div>
                      )}
                      {/* /deliveryfee */}
                    </div>
                    {/* /subtotal */}

                    {/* /total */}
                    <div className="total">
                      <div className="text">Total to pay</div>
                      <div className="price">
                        {totalAfterDiscount > 0
                          ? formatCurrency(totalAfterDiscount)
                          : formatCurrency(
                              subTotal + deliveryItem?.Price + couponCodePrice
                            )}
                      </div>
                      <div className="gst">
                        Inclusive of GST where applicable
                      </div>
                    </div>
                    {/* /total */}

                    <a
                      className="blackbutton"
                      onClick={async() => {
                        console.log("promoCode",promoCode)
                        if (promoCode) {
                          handlePromoCodeApplication().then((response: any) => {
                            if (
                              response?.status &&
                              response?.status == "success"
                            ) {
                              startCheckOut();
                            }
                          });
                        } else {
                          startCheckOut();
                        }
                      }}
                    >
                      {is_loading ? (
                        <Loader
                          type="TailSpin"
                          color="white"
                          height={18}
                          width={18}
                        />
                      ) : (
                        "CHECKOUT"
                      )}
                    </a>

                    {/* greynote */}
                    {dynamic_text !== "" && (
                      <div className="greynote">{dynamic_text}</div>
                    )}
                    {/* greynote */}
                  </div>
                  {/* /order-summary */}
                </div>
                {/* /checkout-box */}
              </div>
              {/* /right */}
            </div>
            {/* /checkout */}
          </div>
        ) : (
          <div className="content">
            {/* empty cart */}
            <div className="empty-cart">
              <div className="message">There are no items in your bag.</div>

              <Link to={"/"} className="blackbutton">
                Continue Shopping
              </Link>

              {/* you might also like */}
              <section className="related">
                <div className="title capitalize">
                  These popular items might interest you
                </div>

                {/* /minicarousel*/}
                <div className="minicarousel four">
                  {isTabletOrMobile || isTabletOrMobileDevice
                    ? renderMiniSlider(trendingProducts, 2)
                    : renderMiniSlider(trendingProducts, 4)}
                </div>
                {/* /minicarousel*/}
              </section>
              {/* /you might also like */}
            </div>
            {/* /empty-cart */}
          </div>
        )}
        {/* /content*/}
      </div>
      {/* /container */}

      {/* footer */}
      <Footer
        props={props}
        categoriesArray={props?.allCategories ? props?.allCategories : []}
      />
      {/* /footer */}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { cart_count, cart_amount, acf, allCategories } = state.UserReducer;
  return { cart_count, cart_amount, acf, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
};
export default connect(mapStateToProps, actions)(MyBag);
